import { PartialStoreState } from '../typings'

export function selectRoutingAssistantConversations(state: PartialStoreState) {
  return state.domain.publicData.routingAssistant.conversations
}

export function selectRoutingAssistantLastConversationId(state: PartialStoreState) {
  return state.domain.publicData.routingAssistant.lastConversationId
}
